import Tcb from '@/tcb'
const Companie = {
  data: () => ({
    latestCompanie: []
  }),
  methods: {
    async getCompanie () {
      const limit = 10
      const db = Tcb.database()
      try {
        const query = db.collection('companie').orderBy('_createTime', 'desc').limit(limit)
        const res = await query.get()
        if (res.data.length > 0) {
          this.latestCompanie = res.data.map(item => {
            const { _id, title, logo } = item
            return {
              id: _id,
              imgSrc: logo,
              title
            }
          })
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
const Supplier = {
  data: () => ({
    latestSupplier: []
  }),
  methods: {
    async getSupplier () {
      const limit = 10
      const db = Tcb.database()
      try {
        const query = db.collection('supplier').orderBy('_createTime', 'desc').limit(limit)
        const res = await query.get()
        if (res.data.length > 0) {
          this.latestSupplier = res.data.map(item => {
            const { _id, title, logo } = item
            return {
              id: _id,
              imgSrc: logo,
              title
            }
          })
          // console.log('latestSupplier', this.latestSupplier)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
export {
  Companie,
  Supplier
}
